import { Box, Container,  Grid, Typography } from "@mui/material";


const Mission = () => {
  return (
    <Box
      sx={{
        position: "relative",
        backgroundImage: `url("https://dprstorage.b-cdn.net/RW/leadgen/mission.webp")`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        py: 14,
        overflow: "hidden",
      }}
    >
      {/* LIGHT BLUE OVERLAY (LESS INTENSITY) */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          background: `
            linear-gradient(
              135deg,
              rgba(15, 99, 165, 0.65),
              rgba(15, 99, 165, 0.45)
            )
          `,
        }}
      />

      {/* SOFT GLASS LAYER (VERY LIGHT) */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          backdropFilter: "blur(6px)",   // 🔥 reduced blur
          background: "rgba(255,255,255,0.02)", // 🔥 very light glass
        }}
      />

      {/* GLOSS LIGHT (TOP LEFT) */}
      <Box
        sx={{
          position: "absolute",
          top: "-20%",
          left: "-10%",
          width: "600px",
          height: "600px",
          background: "radial-gradient(circle, rgba(255,255,255,0.18), transparent 70%)",
          filter: "blur(60px)",
        }}
      />

      {/* SECOND GLOW */}
      <Box
        sx={{
          position: "absolute",
          bottom: "-20%",
          right: "-10%",
          width: "400px",
          height: "400px",
          background: "radial-gradient(circle, rgba(255,255,255,0.12), transparent 70%)",
          filter: "blur(50px)",
        }}
      />

      {/* CONTENT */}
      <Container sx={{ position: "relative", zIndex: 2 }}>
        <Grid container spacing={10}>
          
          {/* LEFT */}
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                width: 50,
                height: 3,
                mb: 2,
                background: "rgba(255,255,255,0.8)",
                mx: { xs: "auto", md: 0 },
              }}
            />

            <Typography
            variant="h4"
              sx={{
                
                fontSize: 34,
                color: "#ffffff",
                fontWeight: 600,
                mb: 3,
                textAlign:{xs:'center', md:'start'}
              }}
            >
              Our Mission
            </Typography>

            <Typography
            variant="body2"
              sx={{
                fontSize: 17,
                color: "rgba(255,255,255,0.95)",
                lineHeight: 1.8,
                 textAlign:{xs:'center', md:'start'}
              }}
            >
              To build structured sales ecosystems that turn demand into predictable revenue for real estate developers.
            </Typography>
          </Grid>

          {/* RIGHT */}
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                width: 50,
                height: 3,
                mb: 3,
                background: "rgba(255,255,255,0.8)",
                mx: { xs: "auto", md: 0 },
               
              }}
            />

            <Typography
            variant="h4"
              sx={{
                textAlign:{xs:'center', md:'start'},
                fontSize: 34,
                color: "#ffffff",
                fontWeight: 600,
                mb: 3,
              }}
            >
              Our Vision
            </Typography>

            <Typography
            variant="body2"
              sx={{
                fontSize: 17,
                color: "rgba(255,255,255,0.95)",
                lineHeight: 1.8,
                textAlign:{xs:'center', md:'start'}
              }}
            >
              To redefine luxury real estate sales through sharper positioning, stronger systems, and execution that ensures consistent cash flow.

            </Typography>
          </Grid>

        </Grid>
      </Container>
    </Box>
  );
};

export default Mission;